
/* styles */
require("!!vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-rewriter?id=data-v-393ed3bc!less-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./vue-xlsx-table.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./vue-xlsx-table.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-393ed3bc!../node_modules/vue-loader/lib/selector?type=template&index=0!./vue-xlsx-table.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/vue-xlsx-table.vue
// module id = 2
// module chunks = 0